module.exports = __webpack_public_path__ + "fonts/7235be49-0fbf-499c-b3b6-32d85e74fea9.58727183.eot";